import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ToastContainer as ReactToastifyContainer } from 'react-toastify';
import { Z_INDEX } from '../../constants/zIndex';
import 'react-toastify/dist/ReactToastify.css';

interface ToastPortalProps {
  containerId?: string;
}

export function ToastPortal({ containerId = 'toast-portal-root' }: ToastPortalProps) {
  useEffect(() => {
    // Criar o container do portal se não existir
    let portalContainer = document.getElementById(containerId);
    
    if (!portalContainer) {
      portalContainer = document.createElement('div');
      portalContainer.id = containerId;
      // Posicionar o container no topo da hierarquia
      portalContainer.style.cssText = `
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        height: 100% !important;
        pointer-events: none !important;
        z-index: ${Z_INDEX.TOAST} !important;
      `;
      document.body.appendChild(portalContainer);
    }

    return () => {
      // Não remover o container para evitar problemas de re-renderização
      // O container será reutilizado
    };
  }, [containerId]);

  const portalContainer = document.getElementById(containerId);

  if (!portalContainer) {
    return null;
  }

  return createPortal(
    <ReactToastifyContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      style={{
        pointerEvents: 'auto',
      }}
    />,
    portalContainer
  );
}

export default ToastPortal;
